export default function postMessageForLab(payload) {
  if (__ENV__ === 'production') {
    if (document.referrer.includes('customink.com')) {
      window.parent.postMessage(payload, '*');
    }
  } else {
    window.parent.postMessage(payload, '*');
  }
}
